import { useState, useEffect, useCallback } from 'react'
import I18n from '/src/utils/translations'

export function useGPSLocation(initialValue, show) {
  const [data, setData] = useState(() => parseInitial(initialValue))

  function parseInitial(value) {
    let latitude = ''
    let longitude = ''
    if (value) {
      try {
        const [lat, lng] = JSON.parse(value)
        latitude = lat?.toString() || ''
        longitude = lng?.toString() || ''
      } catch {
      }
    }
    return { 
      latitude, 
      longitude, 
      isLoading: false, 
      error: '', 
      showMap: false 
    }
  }

  useEffect(() => {
    if (show) {
      setData(prev => ({ ...prev, ...parseInitial(initialValue) }))
    }
  }, [show, initialValue])

  const updateData = useCallback((updates) => {
    setData(prev => ({ ...prev, ...updates }))
  }, [])

  const getCurrentLocation = useCallback(() => {
    if (!navigator.geolocation) {
      updateData({ error: I18n.t('form.inputs.gps.geolocation_not_supported') })
      return
    }
    updateData({ isLoading: true, error: '' })

    navigator.geolocation.getCurrentPosition(
      pos =>
        updateData({
          latitude: pos.coords.latitude.toString(),
          longitude: pos.coords.longitude.toString(),
          isLoading: false,
        }),
      () =>
        updateData({
          error: I18n.t('form.inputs.gps.location_error'),
          isLoading: false,
        }),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    )
  }, [updateData])

  const handleClear = useCallback(() => {
    updateData({ latitude: '', longitude: '', error: '' })
  }, [updateData])

  const handleMapLocationSelect = useCallback(
    (lat, lng) => {
      updateData({
        latitude: lat.toString(),
        longitude: lng.toString(),
        error: '',
      })
    },
    [updateData]
  )

  const getMapCenter = useCallback(() => {
    const lat = parseFloat(data.latitude)
    const lng = parseFloat(data.longitude)
    if (!Number.isNaN(lat) && !Number.isNaN(lng)) return { lat, lng }
    return { lat: -14.235, lng: -51.9253 }
  }, [data.latitude, data.longitude])

  const hasCoordinates = data.latitude && data.longitude
  const canSave = hasCoordinates && !data.isLoading

  return {
    data,
    updateData,
    getCurrentLocation,
    handleClear,
    handleMapLocationSelect,
    getMapCenter,
    canSave,
    hasCoordinates
  }
}